import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'tycka-star-component',
  styleUrl: 'star-component.css',
  shadow: true,
})
export class ReviewRating {
  @Prop() filledStar: number = 1;
  @Prop() fillColor: string = '#000000';
  @Prop() emptyColor: string = '#CED3D8';
  @Prop() marginBottom: string = '0';

  getFillPercentage() {
    return `${Math.max(0, Math.min(100, this.filledStar * 100))}%`;
  }

  render() {
    const fillPercentage = this.getFillPercentage();

    return (
      <div class="star" part="star variableratingspecialcolor variablestarsspecialcolor">
        <svg
          style={{ width: '16px', height: '15px', marginBottom: this.marginBottom }}
          viewBox="0 0 14 13"
          xmlns="http://www.w3.org/2000/svg"
          part="star-svg"
        >
          <defs>
            <linearGradient id="star-fill" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset={fillPercentage} stop-color={`var(--starsspecialcolor, ${this.fillColor})`} />
              <stop offset={fillPercentage} stop-color={`var(--ratingspecialcolor, ${this.emptyColor})`} />
              <stop offset="100%" stop-color={`var(--ratingspecialcolor, ${this.emptyColor})`} />
            </linearGradient>
          </defs>
          <path
            d="M6.52346 0.500355C6.67111 0.0354989 7.32889 0.0355003 7.47654 0.500356L8.68538 4.3063C8.75132 4.51391 8.94408 4.65494 9.16192 4.65494H13.0975C13.5791 4.65494 13.7823 5.26895 13.3958 5.55624L10.1924 7.93714C10.0211 8.06444 9.94953 8.28641 10.0141 8.4898L11.2331 12.3276C11.38 12.7902 10.8479 13.1698 10.4583 12.8802L7.29826 10.5316C7.1212 10.4 6.8788 10.4 6.70174 10.5316L3.54173 12.8802C3.15212 13.1698 2.61997 12.7902 2.76692 12.3276L3.98587 8.4898C4.05047 8.28641 3.97886 8.06444 3.80759 7.93714L0.604199 5.55624C0.217665 5.26895 0.420857 4.65494 0.902462 4.65494H4.83808C5.05592 4.65494 5.24868 4.51391 5.31462 4.3063L6.52346 0.500355Z"
            fill="url(#star-fill)"
          />
        </svg>
        <slot name="rating"></slot>
      </div>
    );
  }
}
